import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Navigation } from '../components/Navigation';
import { MobileNav } from '../components/MobileNav';
import { MasonryGrid } from '../components/MasonryGrid';
import { PinCard } from '../components/PinCard';
import { BottomSheet } from '../components/BottomSheet';
import { CategoryTabs } from '../components/CategoryTabs';
import { CreatePinModal } from '../components/CreatePinModal';
import { SearchOverlay } from '../components/SearchOverlay';
import { MessagesView } from '../components/MessagesView';
import { ProfileView } from '../components/ProfileView';
import { usePins } from '../hooks/usePins';
import { useBoards } from '../hooks/useBoards';
import { Pin } from '../types';
export function HomePage() {
  const [selectedPin, setSelectedPin] = useState<Pin | null>(null);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isMessagesOpen, setIsMessagesOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [mobileActiveTab, setMobileActiveTab] = useState<'home' | 'search' | 'create' | 'messages' | 'profile'>('home');
  const {
    pins,
    allPins,
    selectedCategory,
    setSelectedCategory,
    addPin,
    toggleLike,
    savePin,
    currentUser
  } = usePins();
  const {
    boards,
    createBoard
  } = useBoards();
  const handleMobileTabChange = (tab: 'home' | 'search' | 'create' | 'messages' | 'profile') => {
    setMobileActiveTab(tab);
    // Close all views first
    setIsSearchOpen(false);
    setIsMessagesOpen(false);
    setIsProfileOpen(false);
    // Open the selected view
    if (tab === 'search') {
      setIsSearchOpen(true);
    } else if (tab === 'messages') {
      setIsMessagesOpen(true);
    } else if (tab === 'profile') {
      setIsProfileOpen(true);
    }
  };
  const handleCreateClick = () => {
    setIsCreateModalOpen(true);
  };
  const handleBackToHome = () => {
    setMobileActiveTab('home');
    setIsSearchOpen(false);
    setIsMessagesOpen(false);
    setIsProfileOpen(false);
  };
  return <div className="min-h-screen bg-white pb-20 md:pb-0" data-id="element-335">
      <Navigation user={currentUser} onCreateClick={handleCreateClick} data-id="element-336" />

      <CategoryTabs selected={selectedCategory} onSelect={setSelectedCategory} data-id="element-337" />

      <main className="pt-6" data-id="element-338">
        <MasonryGrid data-id="element-339">
          {pins.map(pin => <PinCard key={pin.id} pin={pin} boards={boards} onClick={p => setSelectedPin(p)} onToggleLike={toggleLike} onSave={savePin} onCreateBoard={createBoard} data-id="element-340" />)}
        </MasonryGrid>

        {pins.length === 0 && <div className="text-center py-20" data-id="element-341">
            <p className="text-gray-500 text-lg" data-id="element-342">
              No pins found in this category
            </p>
            <p className="text-gray-400 text-sm mt-1" data-id="element-343">
              Try selecting a different category
            </p>
          </div>}
      </main>

      <BottomSheet pin={selectedPin} isOpen={!!selectedPin} onClose={() => setSelectedPin(null)} onToggleLike={toggleLike} data-id="element-344" />

      <CreatePinModal isOpen={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)} onSubmit={addPin} data-id="element-345" />

      <SearchOverlay isOpen={isSearchOpen} onClose={handleBackToHome} data-id="element-346" />

      <AnimatePresence data-id="element-347">
        {isMessagesOpen && <MessagesView onBack={handleBackToHome} data-id="element-348" />}
      </AnimatePresence>

      <AnimatePresence data-id="element-349">
        {isProfileOpen && <ProfileView user={currentUser} savedPins={allPins.filter(p => p.isSaved)} boards={boards} onBack={handleBackToHome} data-id="element-350" />}
      </AnimatePresence>

      <MobileNav activeTab={mobileActiveTab} onTabChange={handleMobileTabChange} onCreateClick={handleCreateClick} data-id="element-351" />
    </div>;
}